// extracted by mini-css-extract-plugin
module.exports = {"app-div-nodata":"index_app-div-nodata__I_E9h","appDivNodata":"index_app-div-nodata__I_E9h"};